import axios from 'axios'
import { StaticImage } from 'gatsby-plugin-image'
import { Link, withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addLocation, handleUserLogin, handleUserLogout } from '../../redux/actions'
import { initAmplitude, logAmplitudeEvent } from '../../services/amplitude'
import { handleLogin, handleLogout } from '../../services/auth'
import LocationSearch from '../location-search/LocationSearch'
import "./Nav.css"

const logo = {
  src: '../../images/logo-sm.jpg',
  alt: 'Buxbear logo'
}
class Nav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hamOn: false,
      accountMenuOn: false,
      showLanguageDialog: false,
      user: null
    }
  }
  toggleHam() {
    const { hamOn } = this.state
    this.setState({
      hamOn: !hamOn
    })
  }
  toggleAccountMenu() {
    const { accountMenuOn } = this.state
    this.setState({
      accountMenuOn: !accountMenuOn
    })
  }
  dismissChangeLanguageDialog() {
    this.setState({
      showLanguageDialog: false
    })
  }
  changeLanguage(e, langId) {
    e.preventDefault()
    this.setState({
      showLanguageDialog: true
    })
    logAmplitudeEvent(
      'Clicked on language button',
      { language: langId }
    )
  }
  capitalize(str) {
    return str && str.split(' ').map(word => `${word[0].toUpperCase()}${word.slice(1)}`).join(' ')
  }
  logOut() {
    handleLogout(success => {
      const { originalPath } = this.props.pageContext.i18n
      if (success) {
        this.toggleAccountMenu()
        this.props.handleUserLogout()
        if (['/account/', '/admin/'].includes(originalPath)) {
          setTimeout(() => {
            window.location.href = '/'
          }, 200)
        }
      } else {
        this.toggleAccountMenu()
      }
    })
  }
  navigateTo(page) {
    const { originalPath, language, routed } = this.props.pageContext.i18n
    let href
    const search = window.location.search
    if (originalPath === '/' || originalPath.split('/')[1] === 'location') {
      const el = document.querySelector(`${page.substring(1)}`)
      window.scrollBy(0, el.getBoundingClientRect().top)
    } else {
      href = `${routed ? `/${language}` : ''}${page}`
      window.location.href = href
    }
  }
  componentDidMount() {
    const { user, page } = this.props
    axios.defaults.withCredentials = true
    axios.defaults.credentials = 'include'
    axios.defaults.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
    const logUtm = () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const urlParams = {}
      for (const key of urlSearchParams.keys()) {
        urlParams[key] = urlSearchParams.get(key)
      }
      if (urlParams.utm_source || urlParams.utm_medium || urlParams.utm_campaign) {
        logAmplitudeEvent('Ad source', {
          utmSource: urlParams.utm_source,
          utmMedium: urlParams.utm_medium,
          utmCampaign: urlParams.utm_campaign
        }, () => {
          const newUrlParams = JSON.parse(JSON.stringify(urlParams))
          delete newUrlParams.utm_source
          delete newUrlParams.utm_medium
          delete newUrlParams.utm_campaign
          delete newUrlParams.utm_adgroup
          const urlParamsString = Object.keys(newUrlParams).reduce((acc, cur) => newUrlParams[cur] ? `${acc}${cur}=${newUrlParams[cur]}&` : acc, '?')
          window.history.replaceState({}, document.title, `/${urlParamsString.slice(0, -1)}`)
        })
      }
    }
    const handleLoginCallback = (user) => {
      initAmplitude(user._id,
        {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          preferredLanguage: user.preferredLanguage,
          role: user.role,
          createdAt: user.createdAt,
          updatedAt: user.updatedAt,
          loginProvider: user.loginProvider,
          lastSignIn: user.lastSignIn,
          isBusiness: user.isBusiness,
          businessName: user.businessName,
          verified: user.verified
        },
        () => {
        logAmplitudeEvent('Visited page', { page })
        logUtm()
      })
    }
    handleLogin(user => {
      if (user) {
        this.props.handleUserLogin(user)
        handleLoginCallback(user)
        // todo: delete this
        const event = new Event("login")
        document.dispatchEvent(event)
        //
      } else {
        this.props.handleUserLogout()
        initAmplitude(null, null, () => {
          logAmplitudeEvent('Visited page', { page })
          logUtm()
        })
      }
    })
    axios
      .get(`${process.env.BACKEND_URL}api/locations`)
      .then(res => {
        if (res.data) {
          res.data.map(location => {
            this.props.addLocation(location)
          })
        }
      })
  }
  render() {
    const { t, pageContext, user } = this.props
    const { hamOn, accountMenuOn, showLanguageDialog } = this.state
    const { originalPath, language, routed } = pageContext.i18n
    return (
      <nav className={`nav-wrap${hamOn ? ' on' : ''}`}>
        <div className="nav-left">
          <a className="nav-logo-link" href="/">
            <StaticImage 
              className="nav-logo"
              loading="eager" 
              placeholder="tracedSVG"
              objectFit="contain"
              {...logo} 
            />
          </a>
          <LocationSearch small nav rounded showButton />
        </div>
        <div className="nav-right">
          {t(`nav:links`, { returnObjects: true }).map((el, index) => {
            return (
              <button
                key={index}
                className="nav-link"
                onClick={() => this.navigateTo(el.url)}
              >
                {el.text}
              </button>
            )
          })}
          {(!user || !user._id) && (
            <Link
              className="nav-sign-in-button"
              to={t(`nav:login.url`)}
              language={language}
            >
              {t(`nav:login.text`)}
            </Link>
          )}
          {user && user._id && (
            <div className="nav-account-wrap" id="nav-account-wrap">
              <button className="nav-account-greeting" onClick={() => this.toggleAccountMenu()}>
                {t(`nav:account.greeting`, {name: this.capitalize(user.firstName)})}
                <span className="nav-account-arrow-wrap">
                  <svg
                    width="18"
                    height="9"
                    viewBox="0 0 18 8.9"
                    className="select-arrow"
                  >
                    <path
                      fill="none"
                      className="select-arrow-path"
                      strokeLinejoin="round"
                      strokeWidth="3"
                      d="M.6.8l9 6.8L17.4.8"
                      data-name="Path 81"
                    ></path>
                  </svg>
                </span>
              </button>
              {accountMenuOn && (
                <div className="nav-account-menu">
                  {(user.role !== 'admin' && user.role !== 'superadmin') && (
                    <a href="/account" className="nav-account-menu-item">
                      {t(`nav:account.account`)}
                    </a>
                  )}
                  {(user.role === 'admin' || user.role === 'superadmin') && (
                    <a href="/admin" className="nav-account-menu-item">
                      {t(`nav:account.admin`)}
                    </a>
                  )}
                  <button className="nav-account-menu-item" onClick={() => this.logOut()}>
                    {t(`nav:account.logout`)}
                  </button>
                </div>
              )}
            </div>
          )}
          <div className="nav-ham-wrap">
            <div
              role="button"
              tabIndex="0"
              className="nav-ham flex-center"
              onClick={() => this.toggleHam()}
            >
              <div className="nav-ham-icon center">
                <div className="nav-ham-line line-1"></div>
                <div className="nav-ham-line line-2"></div>
                <div className="nav-ham-line line-3"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="nav-mobile-wrap">
          <div className="nav-mobile-background" />
          <div className="nav-mobile-inner-wrap">
            {t(`nav:links`, { returnObjects: true }).map((el, index) => {
              return (
                <a
                  key={index}
                  className="nav-link"
                  href={`${routed ? `/${language}` : ''}${el.url}`}
                  language={language}
                >
                  {el.text}
                </a>
              )
            })}
            <div className="nav-meta-wrap">
              <div className="nav-language-wrap">
                <i className="material-icons-round">language</i>
                {t(`nav:languages`, {returnObjects: true }).map(el => {
                  return (
                    <button
                      key={el.id}
                      className={`nav-language-button${language === el.id ? ' active' : ''}`}
                      to={originalPath}
                      language={el.id}
                      onClick={(e) => language !== el.id && this.changeLanguage(e, el.id)}
                    >
                      {el.text}
                    </button>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        {showLanguageDialog && (
          <div className="dialog-wrap">
            <div role="button" tabIndex="0" className="dialog-background" onClick={() => this.dismissChangeLanguageDialog()} />
            <div className="dialog-content">
              <div role="button" tabIndex="0" className="dialog-close-button" onClick={() => this.dismissChangeLanguageDialog()}>
                <div className="dialog-close-line line-1" />
                <div className="dialog-close-line line-2" />
              </div>
              <p className="nav-change-language-text">
                {t(`nav:changeLanguageDialog.text`)}
                <a className="nav-change-language-email" href={`mailto:${t(`nav:changeLanguageDialog.email`)}`}>
                  {t(`nav:changeLanguageDialog.email`)}
                </a>.
              </p>
              <br />
              <p className="nav-change-language-end">
                {t(`nav:changeLanguageDialog.closing`)}
              </p>
              <p className="nav-change-language-end">
                {t(`nav:changeLanguageDialog.signature`)}
              </p>
            </div>
          </div>
        )}
      </nav>
    )
  }
}
const mapStateToProps = state => ({
  user: state.user
})
const mapDispatchToProps = dispatch => ({
  addLocation: location => dispatch(addLocation(location)),
  handleUserLogin: (payload) => dispatch(handleUserLogin(payload)),
  handleUserLogout: () => dispatch(handleUserLogout())
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(['nav'])(Nav))
